(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/table-holder.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/table-holder.js');
"use strict";


const TableHolder = _ref => {
  let {
    label = '',
    children,
    iconAddon = null
  } = _ref;
  return React.createElement("div", {
    className: "table-holder f-content"
  }, React.createElement("div", {
    className: "table-holder-title-container"
  }, React.createElement("h2", {
    className: "h2 table-holder-header"
  }, label), iconAddon), children);
};
setGlobal('svs.components.tipsen.routeResult.TableHolder', TableHolder);

 })(window);